import { useCreateMutation } from '../../../lib/utils/createMutation';
import { UseMutationResult } from '@tanstack/react-query';
import { AuthRequest, AuthResponse } from '../../../types/common/AuthType';
import AuthApi from '../../../lib/api/auth/AuthApi';
import { setRequestForm } from '../../../lib/common';
import { AxiosError } from 'axios';
import toastMsg from '../../../lib/toastMsg';
import authToastMsg from '../../../constants/service/toastMsg/authToastMsg';

const useLogin = (): UseMutationResult<AuthResponse, unknown, AuthRequest, unknown> => {
  return useCreateMutation<AuthRequest, AuthResponse>({
    queryKey: ['userLogin'],
    apiFunction: async (payload: AuthRequest) => {
      const res = await AuthApi.login(setRequestForm(payload));
      if ('msg' in res) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // TODO: v2 api로 변경 시 에러 처리를 보다 명확하게 처리
        throw new Error(res.msg);
      } else {
        return res;
      }
    },
    onSuccess: () => {
      toastMsg.success(authToastMsg.LOGIN_SUCCESS);
    },
    onError: (error: AxiosError) => {
      if (error.message) {
        toastMsg.error(error.message);
        return;
      }
      toastMsg.error(authToastMsg.LOGIN_ERROR, error);
    },
  });
};

export default useLogin;
